import Component from '../lib/Component'
import Flickity from 'flickity'

export default class CardSlideshow extends Component {
  constructor (elem, APP) {
    super(elem, APP)
    this.sliderElem = this.elem.querySelector('.js-slideshow')
    this.nextBtn = this.elem.querySelector('.js-CardSlideshow__next')
    this.prevBtn = this.elem.querySelector('.js-CardSlideshow__prev')
    this.slider = null
  }

  initSlider () {
    this.slider = new Flickity(this.sliderElem, {
      wrapAround: true,
      contain: true,
      prevNextButtons: false
    })
  }

  initSliderButtons () {
    this.nextBtn.addEventListener('click', () => this.slider.previous())
    this.prevBtn.addEventListener('click', () => this.slider.next())
  }

  init () {
    this.initSlider()
    this.initSliderButtons()
  }
}
